module.exports = __webpack_public_path__ + "static/media/home9.bff306fa.jpg";